export const moneys={
    '台灣':'NT$',
    'Malaysia':'RM',
    '日本':'￥',
    'Singapore':'SGD',
    'ประเทศไทย':'฿',
    '香港':'HK$'
}


//////////////////
// WEBPACK FOOTER
// ./static/moneyString.js
// module id = qhc6
// module chunks = 1